@if ((paymentMilestoneQuery.selectLoading() | async) === true) {
  <div class="spinner m-auto mt-40 h-32 w-32 border-8"></div>
}

@if ((paymentMilestoneQuery.selectLoading() | async) === false) {
  <div>
    <div class="mb-4 flex justify-end">
      @if ((editModeGrid$ | async) === false) {
        <aux-button
          variant="secondary"
          label="Edit"
          icon="Pencil"
          [onClick]="editGrid.bind(this)"
        />
      }

      @if ((editModeGrid$ | async) === true) {
        <aux-button
          variant="secondary"
          label="Cancel"
          icon="X"
          [onClick]="cancelEditMode.bind(this)"
        />
      }

      @if ((editModeGrid$ | async) === true) {
        <aux-button
          variant="success"
          label="Save"
          class="ml-1"
          icon="Check"
          [disabled]="!hasChanges"
          [onClick]="onSaveAll"
        />
      }
    </div>

    <ag-grid-angular
      id="paymentMilestonesGrid"
      class="ag-theme-aux mb-4 tabular-nums"
      [rowData]="gridData$ | async"
      [gridOptions]="gridOptions"
      [enableFillHandle]="(editModeGrid$ | async) === true"
      (gridReady)="gridReady($event)"
      (cellValueChanged)="cellValueChanged($event)"
      (gridSizeChanged)="sizeColumnsToFit()"
    />

    <div class="mt-4">
      @if ((editModeGrid$ | async) === true) {
        <aux-button
          variant="primary"
          label="Add Payment Milestone"
          [onClick]="onAddPaymentMilestone.bind(this)"
        />
      }
    </div>
  </div>
}
